import React from "react";
import message from "./../assets/message-alert.png";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from 'moment';
import { useNavigate } from "react-router-dom";

const ItemFeedback = ({data}) => {
    const navigate = useNavigate()
    const date =  data.created_at

    const getTimeAgo = (date) => {
        const now = moment();
        const duration = moment.duration(now.diff(moment(date).toDate()));
        if (duration.asHours() < 1) {
          return `${Math.floor(duration.asMinutes())} minutes ago`;
        } else if (duration.asDays() < 1) {
          return `${Math.floor(duration.asHours())} hours ago`;
        } else {
        //   return `${Math.floor(duration.asDays())} days ago`;
        return moment(date).format('MMM DD, YYYY')
        }
      };
    

  return (
    <div className="flex flex-col items-center px-2 sm:px-6 py-2 bg-gray-100">
      {/* Card Container */}
      <div onClick={()=>{navigate('/ComplaintDetail', { state: data })}} className="w-full md:w-full bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 cursor-pointer overflow-hidden">
        <div className="relative flex items-center p-3 sm:p-4">
          {/* Icon */}
          <div className="flex-shrink-0 w-8 sm:w-10 md:w-12 h-8 sm:h-10 md:h-12 rounded-full bg-gray-200 flex items-center justify-center">
            <img
              src={message}
              alt="Feedback Icon"
              className="w-5 sm:w-6 md:w-8 h-5 sm:h-6 md:h-8"
            />
          </div>
          {/* Main Content */}
          <div className="flex-grow ml-3 mr-3 sm:ml-4 sm:mr-4 md:ml-6 sm:mr-6 overflow-hidden">
            {/* Subject */}
            <h3 className="text-gray-700 text-sm sm:text-base md:text-lg font-medium truncate">
              {data.subject}
            </h3>
            {/* Description */}
            <p className="text-gray-500 text-xs sm:text-sm md:text-base mt-1 sm:mt-2 line-clamp-2 overflow-hidden">
              {data.details}
            </p>
          </div>
          {/* Chevron Icon */}
          <div className="ml-auto flex-shrink-0">
            <FontAwesomeIcon
              icon={faChevronRight}
              className="text-[#111111] text-sm sm:text-base md:text-lg"
            />
          </div>
        </div>
        {/* Timestamp */}
        <div className="flex justify-end px-3 sm:px-4 pb-2 text-gray-400 text-xs sm:text-sm">
          <span>{getTimeAgo(date)}</span>
        </div>
      </div>
    </div>
  );
};

export default ItemFeedback;
